import { ReducerBuilder } from './reducerBuilder';
import { BookingsReadDetailsState } from 'acscp/store/bookingsReadDetailsState';
import { Booking } from 'acscp/api/models/booking';
import { BookingsList } from 'acscp/api/models/bookingsList';
import { BookingRequest, BookingsRequest, MarkAsReadRequest } from 'acscp/api/requests';

function getStateWithMarkedBookingVersion(
    oldState: BookingsReadDetailsState,
    bookingId: string,
    contentIdentifier: string
): BookingsReadDetailsState {
    // Any valid booking within the app should have a booking read details record.
    // If such record is missing, then something has broken down,
    // so we shouldn't do anything to not complicate the situation further.
    if (!oldState[bookingId]) {
        return oldState;
    }
    const newState = {...oldState};

    newState[bookingId].read = oldState[bookingId].read || oldState[bookingId].contentIdentifier === contentIdentifier;

    return newState;
}

export const bookingsReadDetailsReducer =
    new ReducerBuilder<BookingsReadDetailsState>({})
        .successfulRequestCase(BookingRequest, (state, bookingDetails: Booking) => ({
            ...state,
            [bookingDetails.id]: {read: bookingDetails.read, contentIdentifier: bookingDetails.contentIdentifier}
        }))
        .successfulRequestCase(BookingsRequest, (state, bookingsList: BookingsList) => {
            const newState = {...state};
            bookingsList.bookings.forEach(b => newState[b.id] = {read: b.read, contentIdentifier: b.contentIdentifier});
            return newState;
        })
        .successfulRequestCase<undefined, MarkAsReadRequest>(MarkAsReadRequest,
            (state, payload, request) => getStateWithMarkedBookingVersion(state, request.bookingId, request.contentIdentifier)
        )
        .build();
